import store from '@/state/store'

export default [
  {
    path: '/Municipios',
    name: 'Municipio',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/municipios/Municipality'),
  },
  {
    path: '/ActualizaTarjetas/:id_tarjeta',
    name: 'ActualizaTarjetas',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/tarjetas/updateCards'),
  },

  {
    path: '/NuevoMunicipio',
    name: 'NuevoMunicipio',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/municipios/newMunicipality'),
  },

  {
    path: '/ActualizaEmpresa/:id_empresa',
    name: 'ActualizaEmpresa',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/empresas/updateEnterprise'),
  },

  {
    path: '/ActualizaPEntrega/:id_punto_entrega',
    name: 'ActualizaPEntrega',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/puntosentrega/updateDeliveryPoints'),
  },

  {
    path: '/NuevaEmpresa',
    name: 'NuevaEmpresa',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/empresas/newEnterprise'),
  },

  {
    path: '/NuevaTarjeta',
    name: 'NuevaTarjeta',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/tarjetas/newCards'),
  },

  {
    path: '/AsignacionCurpTarjeta',
    name: 'AsignacionCurpTarjeta',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/mujeres/AddCurpTarjeta'),
  },

  {
    path: '/RegistroMasivo',
    name: 'RegistroMasivo',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/tarjetas/MRegistration'),
  },
  {
    path: '/NuevoUsuarioAdmin',
    name: 'NuevoUsuarioAdmin',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/newAdminUser'),
  },
  {
    path: '/ActualizaUsuarioAdmin',
    name: 'ActualizaUsuarioAdmin',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/updateAdminUser'),
  },

  {
    path: '/Mujeres',
    name: 'Mujeres',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/mujeres/women'),
  },
  {
    path: '/NuevaMTarjeta',
    name: 'NuevaMTarjeta',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/mujeres/newWomen'),
  },

  {
    path: '/ActualizaMTarjeta',
    name: 'ActualizaMTarjeta',
    props: true,
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/mujeres/updateWomen'),
  },

  {
    path: '/Negocios',
    name: 'Negocios',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/negocios/business'),
  },

  {
    path: '/Descuentos',
    name: 'Descuentos',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/descuentos/discounts'),
  },

  {
    path: '/Categorias',
    name: 'Categorias',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/categorias/category'),
  },

  {
    path: '/Reportes',
    name: 'Reportes',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/Reports'),
  },

  {
    path: '/ActualizaCategorias/:id_cat_descuento',
    name: 'ActualizaCategorias',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/categorias/updateCategory'),
  },

  {
    path: '/ActualizaDescuentos/:id_descuento',
    name: 'ActualizaDescuentos',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/descuentos/updateDiscounts'),
  },

  {
    path: '/NuevaCategoria',
    name: 'NuevaCategoria',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/categorias/newCategory'),
  },

  {
    path: '/NuevoDescuento',
    name: 'NuevoDescuento',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/descuentos/newDiscounts'),
  },

  {
    path: '/ImportarUsuarios',
    name: 'ImportarUsuarios',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/importUsers'),
  },

  {
    path: '/Contactos',
    name: 'Contactos',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/contacts'),
  },

  {
    path: '/ActualizaNegocios/:id_negocio',
    name: 'ActualizaNegocios',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/negocios/updateBusiness'),
  },
  {
    path: '/NuevoNegocio',
    name: 'NuevoNegocio',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/negocios/newBusiness'),
  },
  {
    path: '/sucursales/:id_negocio',
    name: 'sucursales',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/sucursales/sucursales'),
  },
  {
    path: '/actualizaSucursal',
    name: 'actualizaSucursal',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/sucursales/actualizaSucursal'),
  },
  {
    path: '/nuevaSucursal/:id_negocio',
    name: 'nuevaSucursal',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/sucursales/nuevaSucursal'),
  },
  {
    path: '/PuntosVenta',
    name: 'PuntosVenta',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/PuntosVenta'),
  },

  {
    path: '/UsuariosAdmin',
    name: 'UsuariosAdmin',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/AdminUser'),
  },

  {
    path: '/ActualizaMunicipio/:id_municipio',
    name: 'ActualizaMunicipio',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/municipios/updateMunicipality'),
  },

  {
    path: '/NuevoPuntoEntrega',
    name: 'NuevoPuntoEntrega',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/puntosentrega/newDeliveryPoints'),
  },


  {
    path: '/Tarjetas',
    name: 'Tarjetas',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/tarjetas/Cards'),
  },
  {
    path: '/buscadorMujeres',
    name: 'BuscadorMujeres',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/mujeres/buscador'),
  },
  {
    path: '/buscadorTarjetas',
    name: 'BuscadorTarjetas',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/tarjetas/buscador'),
  },
  
  {
    path: '/Empresas',
    name: 'Empresas',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/empresas/Enterprise'),
  },

  {
    path: '/PuntosEntrega',
    name: 'PuntosEntrega',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/puntosentrega/deliveryPoints'),
  },

  {
    path: '/',
    name: 'Home',
    redirect: '/buscadorMujeres',
    meta: {
      authRequired: true,
    },
    // component: () => import('./views/dashboards/mujeres/women'),
  },
  

  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
        //   console.log('firebase');
        //   store.dispatch('auth/logOut')
        // } else {
          console.log('authfack');
          store.dispatch('authfack/logout')
        // }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
        store.dispatch('authfack/logout')
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  
]
